import common from '../common';
import Actor from '../physics/Actor';
import Trap from './Trap';

export default class SpikeTrap extends Trap {
	constructor(state, type) {
		super();

		this._floorbody = null;
		this._activated = true;

		this._type = Actor.TILE;
		this._trapType = type;
		this._animSystem = null;
		this._clip = null;
		this._action = null;

		this._playing = false;
		this.init();
	}

	init() {
		const base = common.assets.model('tile_001');
		const matCopy = new THREE.MeshBasicMaterial({
			map: common.assets.texture(common.levelSettings.floortexture)
		});

		base.material = matCopy;
		this.add(base);

		const spikesObj = common.assets.anim('lab_spikesanim');
		const spikesMesh = spikesObj.scene;

		this._clip = spikesObj.animations[0];
		this._animSystem = new THREE.AnimationMixer(spikesMesh);
		this._action = this._animSystem.clipAction(this._clip);

		this._animSystem.addEventListener('loop', () => {
			P3.audio.playSound('sfx_spike_up_00');
			P3.utils.delay(0.8, () => {
				return P3.audio.playSound('sfx_spike_down_00');
			});
		});

		spikesMesh.position.y += 0.15;
		this.add(spikesMesh);

		this.startAnim();
	}

	_getSize(mesh) {
		mesh.updateMatrixWorld(true);
		const bb = new THREE.Box3().setFromObject(mesh);
		const width = bb.max.x - bb.min.x;
		const height = bb.max.y - bb.min.y;
		const depth = bb.max.z - bb.min.z;

		return {
			width  : width,
			height : height,
			depth  : depth
		};
	}

	update() {
		this._animSystem.update(P3.Ticker.dt);
		// this._spawner.tick(P3.Ticker.dt);
	}

	startAnim() {
		this._action.play();
	}

	stopAnim() {
		this._action.stop();
	}

	playOnce() {
		if (this._playing) {
			return;
		}
		this._playing = true;
		this._action.setLoop(THREE.LoopOnce, 1);
		this._action.play();

		P3.utils.delay(this._clip.duration, () => {
			this._action.setLoop(THREE.LoopRepeat, Infinity);
			this._action.stop();
			this._playing = false;
		}, this);
	}

	get activated() {
		return this._activated;
	}

	get type() {
		return this._type;
	}

	get trapType() {
		return this._trapType;
	}

	set activated(v) {
		this._activated = v;
	}

	set type(v) {
		this._type = v;
	}
}
